import { colors } from '@mui/material'

export default {
  contained: {
    backgroundColor: '#EBA900',
    '&:hover': {
      backgroundColor: '#EB7F00',
    },
  },
}
